import './App.css';
import React, { useState, useEffect } from 'react';
import { Canvas } from '@react-three/fiber';
import { Suspense } from 'react';
import { Hat } from './Hat';
import { OrbitControls } from '@react-three/drei';
import { Collapse, Button, Layout, Modal } from 'antd';
import { CirclePicker } from "react-color";

const { Panel } = Collapse;

function App() {
  // Открытие/закрытие меню

  const [openMenu, setOpenMenu] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const toggleMenu = () => {
    setOpenMenu(!openMenu);
  };

  // Мобильная версия

  const [windowDimenion, detectHW] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  })

  const detectSize = () => {
    detectHW({
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
    })
    if (windowDimenion.winWidth <= 761) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }

  useEffect(() => {
    window.addEventListener('resize', detectSize)

    return () => {
      window.removeEventListener('resize', detectSize)
    }
  }, [windowDimenion])

  // Настройка модели

  const [crownColor, setCrownColor] = useState('#FFFFFF');
  const [capeColor, setCapeColor] = useState('#FFFFFF');
  const [visorColor, setVisorColor] = useState('#FFFFFF');
  const [topPointColor, setTopPointColor] = useState('#FFFFFF');

  const [crownVisibility, setCrownVisibility] = useState(true);
  const [capeVisibility, setCapeVisibility] = useState(true);
  const [visorVisibility, setVisorVisibility] = useState(true);
  const [topPointVisibility, setTopPointVisibility] = useState(true);

  return (
    <>
        <div
          style={{
            background: '#fff',
            display: openMenu ? 'block' : 'none',
            height: isMobile ? '50vh' : '100vh',
            width: isMobile ? '100%' : '400px',
            overflow: 'auto',
            float: !isMobile ? 'left' : null
          }}
        >
          <Collapse
            className='collapse-header-menu'
            bordered={false}
            expandIconPosition='end'
            accordion
          >
            <Panel header="СТЕНКА">
            <CirclePicker width="auto" onChange={color => setCrownColor(color.hex)} />
                <Button className='show-element-btn' type={crownVisibility ? 'default' : 'primary'} onClick={() => setCrownVisibility(crownVisibility ? false : true)}>
                    {crownVisibility ? 'Скрыть' : 'Показать'}
                </Button>
            </Panel>
            <Panel header="ОТЛЕТНАЯ ЧАСТЬ">
                <CirclePicker width="auto" onChange={color => setCapeColor(color.hex)} />
                <Button className='show-element-btn' type={capeVisibility ? 'default' : 'primary'} onClick={() => setCapeVisibility(capeVisibility ? false : true)}>
                    {capeVisibility ? 'Скрыть' : 'Показать'}
                </Button>
            </Panel>
            <Panel header="КОЗЫРЕК">
                <CirclePicker width="auto" onChange={color => setVisorColor(color.hex)} />
                <Button className='show-element-btn' type={visorVisibility ? 'default' : 'primary'} onClick={() => setVisorVisibility(visorVisibility ? false : true)}>
                    {visorVisibility ? 'Скрыть' : 'Показать'}
                </Button>
            </Panel>
            <Panel header="ВЕРХНЯЯ ЗАКЛЕПКА">
                <CirclePicker width="auto" onChange={color => setTopPointColor(color.hex)} />
                <Button className='show-element-btn' type={topPointVisibility ? 'default' : 'primary'} onClick={() => setTopPointVisibility(topPointVisibility ? false : true)}>
                    {topPointVisibility ? 'Скрыть' : 'Показать'}
                </Button>
            </Panel>
          </Collapse>
          <div
            style={{
              borderTop: '1px solid #cecece',
              paddingTop: '30px',
              fontFamily: 'SFUIText-Bold',
              paddingLeft: '76px',
              paddingRight: '120px'
            }}
          >
            ВСЕ ГОТОВО, МНЕ НРАВИТСЯ ВНЕШНИЙ ВИД УНИКАЛЬНОГО ИЗДЕЛИЯ
            <Button
              id='order-button'
              style={{
                margin: '30px 0'
              }}
            >
              ЗАКАЗАТЬ
            </Button>
          </div>
        </div>
        <div>
          <Button
            className='close-menu-btn'
            onClick={() => setOpenMenu(!openMenu) }
            style={{
              padding : isMobile ? '5px 15px' : 'auto',
              opacity: isMobile ? 0.5 : 1,
              left: isMobile ? 'calc(50%)' : 'null',
              transform: isMobile ? 'translateX(-50%)' : '0',
              margin: isMobile ? '20px 0 0 0' : '20px 0 0 20px',
              color: '#224a14'
            }}
          >
            {openMenu ? 'Закрыть меню' : 'Открыть меню'}
          </Button>
          <Canvas
            camera={{ fov: 75, position: [1, 1.2, 3]}}
            style={{
              boxShadow: 'inset 15px 15px 150px 5px #CCCCCC',
              width: 'auto',
              display: 'block',
              position: 'relative',
              height: (isMobile && openMenu) ? '50vh' : '100vh'
            }}
          >
            <Suspense>
              <Hat
                colors={{
                    crownColor,
                    capeColor,
                    visorColor,
                    topPointColor,
                }}
                visibility={{
                  crownVisibility,
                  capeVisibility,
                  visorVisibility,
                  topPointVisibility,
                }}
              />
              <OrbitControls />
              <ambientLight />
              <pointLight intensity={0.2} position={[0, 4, 4]} />
              <directionalLight
                castShadow
                position={[1, 2, -8]}
                intensity={0.2}
              />
            </Suspense>
          </Canvas>
        </div>
    </>
  );
}

export default App;
